/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { MethodProductGroupInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class MethodProductGroupApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'MethodProductGroups');
  }

  find(params?: Record<string, any>): Observable<MethodProductGroupInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<MethodProductGroupInterface[]>(path, httpParams);
  }

  create(data: Partial<MethodProductGroupInterface>): Observable<MethodProductGroupInterface> {
    const path = '';
    return this.post(path, undefined, data);
  }

  updateAttributes(id: number, data: Partial<MethodProductGroupInterface>): Observable<MethodProductGroupInterface> {
    const path = `${id}`;
    return this.put(path, undefined, data);
  }

  deleteById(id: number): Observable<boolean> {
    const path = `${id}`;
    return this.delete<boolean>(path).pipe(map(() => true));
  }
}
